export interface FooterLink {
  name: string;
  link: string;
}

export interface FooterColumn {
  name: string;
  links: FooterLink[];
}

// Pages that are not routed in this SPA are served by insighttimer.com.
export const INSIGHT_TIMER_URL = 'https://insighttimer.com';

export const insightTimerUrl = (path: string): string =>
  `${INSIGHT_TIMER_URL}${path.startsWith('/') ? path : `/${path}`}`;

export const footerTopLinks: FooterLink[] = [
  { name: 'Help', link: 'https://help.insighttimer.com' },
  { name: 'About', link: '/about' },
  { name: 'Careers', link: '/careers' }
];

export const footerColumns: FooterColumn[] = [
  {
    name: 'Benefits',
    links: [
      { name: 'Better sleep', link: insightTimerUrl('/search/sleep') },
      { name: 'Less anxiety', link: insightTimerUrl('/search/anxiety') },
      { name: 'Stress relief', link: insightTimerUrl('/search/stress') },
      { name: 'Focus', link: insightTimerUrl('/search/focus') },
      {
        name: 'Emotional regulation',
        link: insightTimerUrl('/search/emotional-regulation')
      },
      { name: 'Pain relief', link: insightTimerUrl('/search/pain') },
      { name: 'Calm', link: insightTimerUrl('/search/calm') },
      { name: 'Grief support', link: insightTimerUrl('/search/grief') }
    ]
  },
  {
    name: 'Techniques',
    links: [
      { name: 'Yoga Nidra', link: insightTimerUrl('/search/yoga-nidra') },
      { name: 'Body Scan', link: insightTimerUrl('/search/body-scan') },
      { name: 'Breathwork', link: insightTimerUrl('/search/breathwork') },
      { name: 'Vipassana', link: insightTimerUrl('/search/vipassana') },
      { name: 'Sound Healing', link: insightTimerUrl('/search/sound-healing') },
      {
        name: 'Chakra Meditation',
        link: insightTimerUrl('/search/chakra-meditation')
      },
      { name: 'Mindfulness', link: insightTimerUrl('/search/mindfulness') }
    ]
  },
  {
    name: 'Mechanisms',
    links: [
      {
        name: 'Interoceptive awareness',
        link: insightTimerUrl('/search/interoceptive-awareness')
      },
      {
        name: 'Parasympathetic activation',
        link: insightTimerUrl('/search/parasympathetic-activation')
      },
      {
        name: 'Attentional anchoring',
        link: insightTimerUrl('/search/attentional-anchoring')
      },
      {
        name: 'Heart rate variability',
        link: insightTimerUrl('/search/heart-rate-variability')
      },
      {
        name: 'Autonomic balancing',
        link: insightTimerUrl('/search/autonomic-balancing')
      },
      {
        name: 'Muscular relaxation',
        link: insightTimerUrl('/search/muscular-relaxation')
      },
      {
        name: 'Somatic resourcing',
        link: insightTimerUrl('/search/somatic-resourcing')
      }
    ]
  },
  {
    name: 'Directories',
    links: [
      { name: 'Teachers', link: '/meditation-teachers' },
      { name: 'Therapists', link: insightTimerUrl('/therapists') },
      { name: 'Topics', link: '/meditation-topics' },
      { name: 'Courses', link: '/meditation-courses' },
      { name: 'Playlists', link: '/meditation-playlists' },
      { name: 'Live Events', link: '/live' },
      { name: 'Retreats', link: '/retreats' },
      { name: 'Challenges', link: insightTimerUrl('/challenges') },
      { name: 'Techniques A-Z', link: insightTimerUrl('/techniques') }
    ]
  },
  {
    name: 'Company',
    links: [
      { name: 'About', link: '/about' },
      { name: 'Newsroom', link: insightTimerUrl('/news') },
      { name: 'Careers', link: '/careers' },
      { name: 'Help Centre', link: 'https://help.insighttimer.com' }
    ]
  }
];

export const footerSocialLinks = [
  { name: 'Facebook', link: 'https://www.facebook.com/insighttimer' },
  { name: 'Instagram', link: 'https://www.instagram.com/insighttimer' },
  {
    name: 'YouTube',
    link: 'https://www.youtube.com/channel/UCA1raD2uELPTbm-J3h1Z34g'
  },
  { name: 'TikTok', link: 'https://www.tiktok.com/@insighttimer' }
] as const;

export const footerLegalLinks: FooterLink[] = [
  { name: 'Terms of Service', link: '/legal/terms-of-service' },
  { name: 'Privacy Policy', link: '/legal/privacy-policy' },
  {
    name: 'CA Notice at Collection',
    link: '/legal/california-notice-at-collection'
  },
  {
    name: 'Accessibility Statement',
    link: insightTimerUrl('/accessibility-statement')
  }
];
